<template>
  <div>
    <AuBreadcrumb :pages="breadcrumb" />
    <ProgressLoader
      v-if="loading"
      mode="indeterminate"
      color="#5AC396"
      size="150px"
    />
    <Form
      v-else
      padding="20px"
    >
      <template #header>
        {{ titleText }}
      </template>
      <AuInput
        v-model="platform.name"
        :label="$t('myPlatforms.newPlatform.name')"
        :required="requiredFiled.name"
      />
      <AuInput
        v-model="platform.url"
        class="indent"
        :label="$t('myPlatforms.newPlatform.url')"
        :required="requiredFiled.url"
      />

      <AuInput
        v-model="platform.description"
        class="indent"
        :label="$t('myPlatforms.newPlatform.description')"
        type="TextArea"
        clearable
      />
      <AuInput
        v-model="platform.callbackInvestment"
        class="indent"
        :label="$t('myPlatforms.newPlatform.callbackInvestment')"
        :tooltip="$t('myPlatforms.newPlatform.tooltip')"
        :required="requiredFiled.callbackInvestment"
      />
      <div
        v-if="error !== ''"
        class="error indent"
      >
        {{ error }}
      </div>
      <div class="btn-place indent">
        <AuButton
          type="primary"
          width="300px"
          center
          @click="sendEvent"
        >
          {{ buttonText }}
        </AuButton>
      </div>
    </Form>
  </div>
</template>

<script>
import ProgressLoader from "@/loaders/progress-bar";
import { mapActions } from "vuex";
import { url } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default {
  name: "NewPlatform",
  components: { ProgressLoader },
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      v$: useVuelidate(),
      platform: {
        name: "",
        url: "",
        description: "",
        callbackInvestment: ""
      },
      requiredEnable: false,
      error: "",
      loading: false,
      breadcrumb: [
        { key: 0, name: this.$t("router.pages.dashboard"), path: "/" },
        {
          key: 2,
          name: this.$t("router.pages.myPlatforms"),
          path: "/my-platforms"
        }
      ]
    };
  },
  validations() {
    return {
      platform: {
        url: { url },
        callbackInvestment: { url }
      }
    };
  },
  computed: {
    requiredFiled() {
      return ["name", "url", "callbackInvestment"].reduce((acc, key) => {
        acc[key] = this.requiredEnable && this.platform[key].length === 0;
        return acc;
      }, {});
    },

    titleText() {
      return this.id.length === 0 ? this.$t("myPlatforms.newPlatform.title") :
        this.$t("myPlatforms.newPlatform.editTitle");
    },

    buttonText() {
      return this.id.length === 0 ? this.$t("myPlatforms.newPlatform.button") :
        this.$t("myPlatforms.newPlatform.editButton");
    }
  },
  async mounted() {
    if (this.id.length === 0) {
      this.clearFields();
    }
    else {
      await this.setFields();
    }
  },
  methods: {
    ...mapActions({
      getPlatformById: "platforms/getPlatformById"
    }),

    clearFields() {
      Object.keys(this.platform).forEach((key) => (this.platform[key] = ""));
    },

    async setFields() {
      this.loading = true;
      try {
        const resp = await this.getPlatformById(this.id);
        Object.keys(this.platform).forEach(
          (key) => (this.platform[key] = resp.data[key])
        );
        this.platform.id = this.id;
      }
      catch (error) {
        this.$toast.error(
          error.response.data?.message || error.response.data?.detail
        );
      }
      this.loading = false;
    },

    sendEvent() {
      this.requiredEnable = true;
      const isAllCorrect = Object.values(this.requiredFiled).reduce(
        (acc, el) => acc && !el,
        true
      );
      this.v$.platform.url.$touch();
      if (this.v$.platform.url.$errors.length > 0) {
        this.error = this.$t("myPlatforms.newPlatform.urlCorrect");
        return;
      }
      this.v$.platform.callbackInvestment.$touch();
      if (this.v$.platform.callbackInvestment.$errors.length > 0) {
        this.error = this.$t("myPlatforms.newPlatform.callbackCorrect");
        return;
      }

      if (isAllCorrect) {
        this.$emit(this.id.length === 0 ? "add" : "edit", this.platform);
        this.$router.push({ name: "my platforms" });
      }
      else {
        const fieldName = Object.keys(this.requiredFiled).find(
          (key) => this.requiredFiled[key]
        );
        this.error =
          this.$t("myPlatforms.newPlatform.errorField") +
          ": " +
          this.$t(`myPlatforms.newPlatform.${fieldName}`).toLowerCase();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.indent {
  margin-top: 20px;
}
.btn-place {
  display: flex;
  justify-content: center;
}
.error {
  color: red;
}
</style>